import { createAction, props } from '@ngrx/store'
import { ParcelDto, PurchaseCaseDto } from '../../../../api/backend'
import { ExtendedParcelDto } from '../../model/ExtendedPurchaseParcelDto.model'

export const SOURCE = '[Case Edit]'

export const resetState = createAction(
    `${ SOURCE } ResetState`,
)
export const updateAndSetPurchaseCase = createAction(
    `${ SOURCE } LoadAndSetPurchaseCase`, props<{ purchaseCase: PurchaseCaseDto }>(),
)
export const setPurchaseCase = createAction(
    `${ SOURCE } SetPurchaseCase`, props<{ purchaseCase: PurchaseCaseDto }>(),
)
export const orderParcels = createAction(
    `${ SOURCE } OrderParcels`, props<{ orderBy: string; parcelsOrder: any }>(),
)
export const setProperty = createAction(
    `${ SOURCE } SetProperty`, props<{ property: string; value: any }>(),
)
export const setParcelsFeatureGroup = createAction(
    `${ SOURCE } SetParcelsFeatureGroup`, props<{ parcels: ExtendedParcelDto[] }>(),
)
export const noAction = createAction(
    `${ SOURCE } No Action`,
)
export const setCaseIsEditing = createAction(
    `${ SOURCE } SetCaseIsEditing`, props<{ isEditing: boolean }>(),
)
export const setParcels = createAction(
    `${ SOURCE } SetParcels`, props<{ parcels: ParcelDto[] }>(),
)
export const getOwnerships = createAction(
    `${ SOURCE } GetOwnerships`, props<{ parcels: ParcelDto[]; owners: any[] }>(),
)
export const setTotalAcreage = createAction(
    `${ SOURCE } SetTotalAcreage`, props<{ parcels: ExtendedParcelDto[] }>(),
)
export const setParcelProdavanaVymera = createAction(
    `${ SOURCE } SetParcelProdavanaVymera`, props<{ parcelId: number; prodavanaVymera: number }>(),
)
export const addOwner = createAction(
    `${ SOURCE } AddOwner`, props<{ subject: any }>(),
)
export const addOwnerWithDialog = createAction(
    `${ SOURCE } AddOwnerWithDialog`, props<{ subject: any; parcels: ParcelDto[]; owners: any[]; notIncluded: number[] }>(),
)
export const removeOwner = createAction(
    `${ SOURCE } RemoveOwner`, props<{ ownerId: number }>(),
)
export const removeParcel = createAction(
    `${ SOURCE } RemoveParcel`, props<{ parcelId: number }>(),
)
export const removeAllParcels = createAction(
    `${ SOURCE } RemoveAllParcels`,
)
export const setParcelsOrder = createAction(`${SOURCE} setParcelsOrder`,
    props<{ parcelsOrder: {sortedBy: string; desc: boolean} }>()
)
